<template>
    <editing-sub-frame :sub_type="sub_type" :label="label" no-structure>
        <template #head>
            <!--제목, 컴포넌트 기본 공통 -->
            
            <!--     label이 있는 경우에만 폼 활성화        -->
            <template v-if="label">
                <div class="mt-3 mb-1 fw-600 f-90"> Sub label *</div>
                <b-form-input v-model="sub_label" placeholder="필수 입력" />    
            </template>
            
            <div class="mt-3 mb-1 fw-600 f-90"> Sub type </div>
            <div class="d-flex justify-content-between">
                <b-dropdown :text="sub_type" variant="dark-border" class="mr-2">
                    <b-dropdown-item-button v-for="item in sub_types"
                        :key="item.id"
                        @click="selectType(item)"
                        >
                        {{ item }}
                    </b-dropdown-item-button>
                </b-dropdown>
                <b-form-input v-model="sub_name" placeholder="Title (필요시 작성)" > {{ sub_name }} </b-form-input>
            </div>

            <div class="mt-3 mb-1 fw-600 f-90">Description</div>
            <b-textarea v-model="sub_description" placeholder="A1. ㅇㅇㅇ을 관리하고 있습니까?"> {{ sub_description }} </b-textarea>

            <div class="mt-3 mb-1 fw-600 f-90">Info</div>
            <b-textarea v-model="sub_info" placeholder="용어설명, 참고사항, 평가기준 등 답변 참고정보" > {{ sub_info }} </b-textarea>
        </template>

        <template #option>
            <b-list-group>
                <b-list-group-item>
                    <editing-sub-submit-required v-model="submit_required" :sub_code="sub_code" />
                </b-list-group-item>

                <b-form-group
                    label-cols="12"
                    label-cols-md="4"
                    label-cols-xl="2"
                    content-cols="12"
                    content-cols-md="8"
                    content-cols-xl="9"
                    label="해당없음"
                    :label-for="`editing-subs-dffileurl-${sub_code}-enable_na`"
                    class="align-items-center mb-0"
                    >
                    <b-form-checkbox :id="`editing-subs-dffileurl-${sub_code}-enable_na`"
                        v-model="enable_na"
                        >
                        선택지에 '해당없음' 추가
                    </b-form-checkbox>
                </b-form-group>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Risk"
                        :label-for="`editing-subs-dffileurl-${sub_code}-risk`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-dffileurl-${sub_code}-risk`"
                            v-model="sub_risk"
                            >
                            적용
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Tags"
                        :label-for="`editing-subs-dffileurl-${sub_code}-tags`"
                        class="align-items-center mb-0"
                        >
                        <b-input :id="`editing-subs-dffileurl-${sub_code}-tags`" v-model="tags"
                            placeholder="띄어쓰기 대신 _ 사용, 쉼표로 구분"
                            />
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>
        </template>

        <template #footer>
            <div class="text-right">
                <b-button variant="blue" class="mr-2"
                    @click="handleSaveSub"
                    :disabled="is_saving_subs"
                    >
                    <div class="d-flex align-items-center">
                        저장 <b-spinner v-show="is_saving_subs" small class="ml-2" />
                    </div>
                </b-button>
                <b-button @click="$emit('click-cancel')" variant="dark">취소</b-button>
            </div>
        </template>
    </editing-sub-frame>
</template>

<script>
import { EditingSubComponentMixin } from '@core_mixins/EditingSubComponentMixin'

export default {
    name: 'editing-df-file_url2',
    mixins: [EditingSubComponentMixin],
    data() {
        return {}
    },
    methods: {
        async handleSaveSub () {
            this.sub_data_header = {}
            this.sub_data_contents = {}
            await this.saveSub()
            this.$emit('click-save')
        }
    }
}
</script>
